module.exports = __webpack_public_path__ + "img/1.aaddd08d.jpg";